'use client';

import { Category, MarketplaceTag } from '@shared/types';
import { FunctionComponent, useMemo } from 'react';
import styles from './styles.module.scss';
import Link from 'next/link';
import { useIsMarketplace } from '../../../contexts/AppContext/useIsMarketplace';

export type CategoryAndTagSectionProps = {
    categories: Array<Category>;
    tags: Array<MarketplaceTag>;
};

const InnerComp: FunctionComponent<CategoryAndTagSectionProps> = ({ categories, tags }) => {
    const dedupedList = useMemo(() => {
        const combined = [...categories, ...tags];
        return combined.filter((categoryOrTag, index) => {
            const otherIndex = combined.findIndex((otherCategoryOrTag) => {
                return otherCategoryOrTag.name === categoryOrTag.name;
            });
            return index === otherIndex;
        });
    }, [categories, tags]);

    if (dedupedList.length === 0) {
        return null;
    }

    return (
        <section className={styles.course_tags_section} aria-labelledby="category-or-tag-header">
            <h2 id="category-or-tag-header">Tags</h2>
            <ul className={styles.pill_list} aria-label="Tags list">
                {dedupedList.map((categoryOrTag, index) => {
                    return (
                        <li
                            key={`${categoryOrTag.name}-category-${index}`}
                            className={styles.pill_list_item}
                        >
                            <Link
                                href={
                                    'slug' in categoryOrTag && categoryOrTag.slug !== undefined
                                        ? `/courses/${categoryOrTag.slug}`
                                        : `/courses?q=${encodeURIComponent(categoryOrTag.name)}`
                                }
                            >
                                {categoryOrTag.name}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export const CategoryAndTagSection: FunctionComponent<CategoryAndTagSectionProps> = (props) => {
    const isMarketplace = useIsMarketplace();

    if (isMarketplace !== true) {
        return null;
    }

    return <InnerComp {...props} />;
};

export default CategoryAndTagSection;
